module.exports = __webpack_public_path__ + "img/phoneCall@2x.523aa31c.png";